import type { EditorialStatus } from '@buakei/types';

/** How each review state reads (LEGAL-KNOWLEDGE-ENGINE editorial workflow). */
export const STATUS_LABEL: Record<
  EditorialStatus,
  { label: string; tone: 'success' | 'danger' | 'plain' }
> = {
  registered: { label: 'Registered', tone: 'plain' },
  acquired: { label: 'Acquired', tone: 'plain' },
  extracted: { label: 'Extracted', tone: 'plain' },
  review_ready: { label: 'Ready for review', tone: 'plain' },
  under_review: { label: 'Under review', tone: 'plain' },
  approved_for_defined_use: { label: 'Approved for defined use', tone: 'success' },
  provisional: { label: 'Provisional', tone: 'plain' },
  rejected: { label: 'Rejected', tone: 'danger' },
  needs_more_evidence: { label: 'Needs more evidence', tone: 'danger' },
};
